module.exports = __webpack_public_path__ + "img/34.2dccba91.png";